import * as React from "react";

import { PublicPayee } from "api/billingPublic";
import { ShieldCheck } from "Components/ui/icons";
import MetaHosMark from "./MetaHosMark";

const POLICY_LABELS: Array<[keyof PublicPayee["policies"], string]> = [
  ["terms", "Terms"],
  ["privacy", "Privacy"],
  ["refunds", "Refunds and cancellations"],
];

/** Public, logged-out layout for the pay pages (no navbar, mobile first). */
const PayShell: React.FC<{ children?: React.ReactNode; payee?: PublicPayee }> = ({
  children,
  payee,
}) => (
  <div className="min-h-screen w-full bg-background px-4 py-8 text-foreground sm:py-14">
    <div className="mx-auto w-full max-w-lg">
      <header className="mb-6 flex items-center justify-center gap-3">
        <MetaHosMark />
        <div className="leading-tight">
          <p className="text-sm font-semibold uppercase tracking-widest text-foreground">
            Meta16 Labs
          </p>
          <p className="text-xs uppercase tracking-wider text-muted-foreground">
            MetaHOS · TeleOpd
          </p>
        </div>
      </header>
      <main className="rounded-card border border-border bg-surface p-5 shadow-card sm:p-8">
        {children}
      </main>
      <footer className="mt-6 space-y-2 text-center text-xs text-muted-foreground">
        <p className="flex items-center justify-center gap-1.5">
          <ShieldCheck className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          Payments are processed securely by Razorpay on behalf of{" "}
          {payee ? payee.name : "Meta16 Labs"}.
        </p>
        {payee && POLICY_LABELS.some(([key]) => payee.policies[key]) && (
          <p className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
            {POLICY_LABELS.map(([key, label]) =>
              payee.policies[key] ? (
                <a
                  key={key}
                  href={payee.policies[key] as string}
                  target="_blank"
                  rel="noreferrer"
                  className="underline hover:text-foreground"
                >
                  {label}
                </a>
              ) : null
            )}
          </p>
        )}
        {payee && payee.supportEmail && (
          <p>
            Questions about a payment?{" "}
            <a className="underline hover:text-foreground" href={`mailto:${payee.supportEmail}`}>
              {payee.supportEmail}
            </a>
          </p>
        )}
      </footer>
    </div>
  </div>
);

export default PayShell;
